export const getEnvVariable = (key, defaultValue = '') => {
    // Node.js 환경
    if (typeof process !== 'undefined' && process.env) {
        return process.env[key] || defaultValue;
    }
    // Vite/브라우저 환경
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env[key] || defaultValue;
    }
    return defaultValue;
};
// 개별 환경 변수 내보내기
export const DEFAULT_API_URL = getEnvVariable('VITE_DEFAULT_API_URL');
export const SAMSUNG_API_URL = getEnvVariable('VITE_SAMSUNG_API_URL');
export const GIGYA_API_URL = getEnvVariable('VITE_GIGYA_API_URL');
// 모든 환경 변수를 객체로 내보내기
export const ENV = {
    DEFAULT_API_URL,
    SAMSUNG_API_URL,
    GIGYA_API_URL,
};
export default ENV;
